import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function deleteWishlist(wishlistId, wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of deleteWishlist()');
    invariant(brandId, 'brandId is a required param of deleteWishlist()');
    invariant(country, 'country is a required param of deleteWishlist()');
    invariant(uberToken, 'uberToken is a required param of deleteWishlist()');
    invariant(clientId, 'clientId is a required param of deleteWishlist()');
    invariant(wishlistId, 'wishlistId is a required param of deleteWishlist()');

    const headers = { 'Content-Type': 'application/json' };

    const deleteURl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/${wishlistId}`;

    return labelRequest(
        authenticatedRequest(new Request(deleteURl, { headers: new Headers(headers), method: 'DELETE' }), uberToken, clientId, clientSecret),
        'deleteWishlist',
    );
}
